// Dependencies
import { graphql, useStaticQuery } from 'gatsby';

const usePressArticlePostType = () => {
  const { pressArticles } = useStaticQuery(graphql`
    query PressArticles {
      pressArticles: allWpPressArticle {
        nodes {
          id
          uri
          title
          menuOrder
          featuredImage {
            node {
              altText
              gatsbyImage(width: 150, placeholder: NONE)
              localFile {
                publicURL
              }
              mediaDisplayOptions {
                filter
              }
            }
          }
          press {
            featuredInSlider
            articles {
              link
              headline
            }
          }
        }
      }
    }
  `);

  return pressArticles?.nodes;
};

export default usePressArticlePostType;
